<div class="loader-wrapper">
    @if(type==1){
        <div class="ai-diamond-wrapper">
            <div class="loader">
            </div>
       </div>
    }
  
</div>